import ApplicationSerializer from './application';

export default class GroupInviteRegistrationSerializer extends ApplicationSerializer {
  attrs = {
    editToken: {
      serialize: false,
    },
    additionalGuestsEnabled: {
      serialize: false,
    },
    flow: {
      serialize: false,
    },
    signInFields: {
      serialize: false,
    },
    location: {
      serialize: false,
    },
  };

  payloadKeyFromModelName(modelName) {
    if (modelName === 'group-invite-registration') return 'invites';

    return super.payloadKeyFromModelName(modelName);
  }

  serialize(snapshot, options = {}) {
    const json = super.serialize(snapshot, options);
    const { attributes } = json.data;

    const fullName = snapshot.attr('fullName');
    const email = snapshot.attr('email');
    const signInFieldSnapshots = snapshot.hasMany('signInFields');

    attributes['user-data'] = this._generateUserData(fullName, email, signInFieldSnapshots);

    return json;
  }

  _generateUserData(fullName, email, signInFieldSnapshots) {
    const userData = [];

    if (!Array.isArray(signInFieldSnapshots)) return userData;

    signInFieldSnapshots.forEach((fieldSnapshot) => {
      const identifier = fieldSnapshot.attr('identifier');
      const label = fieldSnapshot.attr('label');
      const value = fieldSnapshot.attr('value');

      if (!label) return;

      const fieldValue =
        identifier === 'name' ? (fullName ?? '') : identifier === 'email' ? (email ?? '') : (value ?? '');

      userData.push({
        field: label,
        value: fieldValue,
      });
    });

    return userData;
  }
}
